export enum CronOrIntervalHour {
    CRON_EXPRESSION = 'true',
    INTERVAL_HOUR = 'false',
}